
/**
 * 
 *  On Table > Mobile Remove Sidebar and Place it Inside Hero Block
 *  
 */
if (document.querySelector('.template-post__wrapper-sidebar')) {
  const mediaQuery = window.matchMedia('(max-width: 992px)')
  // Check if the media query is true
  if (mediaQuery.matches) {
    const sidebar = document.querySelector('.template-post__wrapper-sidebar');
    sidebar.remove();

    if(document.querySelector('h1')) {
      const heroBlock = document.querySelector('h1').parentElement;
      const heroTxt = heroBlock.querySelector('h1');
      
      heroBlock.insertBefore(sidebar, heroTxt.nextElementSibling);
    }
  }
}